<template>
  <div class="index">
    <section id="banner">
      <div class="inner">
        <img class="sig-logo" src="../assets/logos/sig-logo.jpg" alt="SIG and Associates Insurance Services Logo">
        <hr>
        <button id="index-quote-button" class="quote-button primary button" v-on:click="focusGetQuote()">Get Quote
        </button>
      </div>
      <video autoplay loop muted playsinline src="../assets/images/banner.mp4"></video>
    </section>

    <section id="main" class="wrapper">
      <div class="inner">
        <div class="content">
          <header class="special">
            <h2>Home, Auto, and Business Insurance in Wichita Falls and Dallas-Fort Worth, Texas.</h2>
            <p>Locally owned and operated, SIG & Associates has delivered quality insurance solutions to individuals in
              Texas, specializing in Home, Auto, and Business insurance coverage. Our team of knowledgeable insurance
              professionals is committed to helping you find a policy that fits your needs. We focus on providing
              personalized attention and exceptional customer service to create an experience that’s difficult to find
              in
              today’s market. At SIG & Associates, we’ll work with you to ensure that you and those you care about most
              are protected.</p>
          </header>
          <hr>
          <GetQuoteForm id="get-quote"/>
          <hr>
        </div>
      </div>
    </section>

    <section id="cta" class="wrapper">
      <div class="inner">
        <div class="highlights">
          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <img src="../assets/images/james-cox-head.png" alt="James Cox (agent) Photograph"/>
                </div>
                <div class="title-xl">James D. Cox</div>
                <div class="title-md">Principal Agent</div>
                <div class="title-md">940-264-7515</div>
                <br>
                <p class="title-sm">
                  813 8th St, Suite 550C
                  <br>
                  Wichita Falls, TX 76301
                </p>
              </header>
              <button class="button primary"  v-on:click="navigateTo('/contact-us')">About Us</button>
            </div>
          </section>
        </div>
      </div>
    </section>

    <section class="wrapper">
      <header class="special">
        <h2>Featured Products</h2>
      </header>
      <div class="inner">
        <div class="highlights">
          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <a href="/home-insurance.html" class="icon fa fa-home" @click="scrollToTop()"><span
                    class="label">Icon</span></a>
                </div>
                <h3><a href="/home-insurance.html">Home Insurance</a></h3>
              </header>
              <p>Look after your biggest investment and everything in it with a proper policy that ensures its
                protection
                in the event of an accident or natural disaster.</p>
            </div>
          </section>
          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <a href="/auto.html" class="icon fa fa-automobile" @click="scrollToTop()"><span class="label">Icon</span></a>
                </div>
                <h3><a href="/auto.html">Auto Insurance</a></h3>
              </header>
              <p>Choosing the right auto insurance is the key to keeping you and your car safe on the road in the event
                of an accident or other vehicle damage.</p>
            </div>
          </section>
          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <a href="/farm.html" class="icon fa fa-envira" @click="scrollToTop()"><span class="label">Icon</span></a>
                </div>
                <h3><a href="/farm.html">Farm Insurance</a></h3>
              </header>
              <p>Preserve your livelihood with an agribusiness policy that safeguards your farm and everything on it,
                from buildings and machinery to crops and livestock.</p>
            </div>
          </section>

          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <a href="/health.html" class="icon fa fa-hospital-o" @click="scrollToTop()"><span
                    class="label">Icon</span></a>
                </div>
                <h3><a href="/health.html">Health Insurance</a></h3>
              </header>
              <p>Making good decisions today can secure a healthy tomorrow for you and your family with individual or
                group plans designed to meet your specifications.</p>
            </div>
          </section>
          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <a href="/life.html" class="icon fa fa-user-o" @click="scrollToTop()"><span class="label">Icon</span></a>
                </div>
                <h3><a href="/life.html">Life Insurance</a></h3>
              </header>
              <p>Provide your family with the security they deserve in the event of your passing with a life insurance
                policy that meets your financial and personal needs.</p>
            </div>
          </section>
          <section>
            <div class="content">
              <header>
                <div class="icon-wrapper">
                  <a href="/business.html" class="icon fa fa-building-o" @click="scrollToTop()"><span
                    class="label">Icon</span></a>
                </div>
                <h3><a href="/business.html">Business Owner Policy</a></h3>
              </header>
              <p>Combine Property, Liability, Crime, and additional insurance services into one convenient policy to
                benefit your small to medium-sized business.</p>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import GetQuoteForm from '@/components/GetQuoteForm'

export default {
  name: 'index',
  methods: {
    navigateTo: function (path) {
      window.scrollTo(0, 0)

      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path)
        this.toggleMenu()
      }
    },
    clearForm: function () {
      let fields = document.querySelectorAll('.user-info-input')

      for (let i = 0; i < fields.length; i++) {
        fields[i].value = ''
      }
    },
    scrollToTop: function () {
      window.scrollTo(0, 0)
    },
    focusGetQuote: function () {
      let element = document.getElementById('get-quote')

      element.scrollIntoView({
        behavior: 'smooth'
      })
    }
  },
  components: {
    GetQuoteForm
  }
}
</script>

<style scoped>
.sig-logo {
  height: 300px;
  padding: 20px 20px 20px 25px;
  background-color: #FFF;
  border-radius: 5px;
}

.inner .button {
  font-size: 1.25em;
}

.inner .icon-wrapper {
  height: 150px;
}

#cta .highlights {
  justify-content: center;
  margin: 0;
}

#cta {
  padding: 4em;
}
</style>



// WEBPACK FOOTER //
// src/components/Index.vue